<div class="utilisation-status-wrapper" [ngSwitch]="type">
  <div *ngSwitchCase="'block'" class="type-{{ type }}">
    <h4 class="title">{{ title }}</h4>
    <span
      class="status"
      [ngStyle]="{background: utilisation?.backgroundColorCode, color: utilisation?.colorCode}"
    >{{ utilisation?.title }}</span>
  </div>
</div>